/**
 * A school licence's manager (the Unity app's "Manage Teachers" panel): the
 * school's teachers, added and removed by e-mail through the manageSchool
 * function (functions/src/schools.ts). A teacher is Premium as soon as they
 * sign in with that e-mail, on the web or in the apps; the manager does not
 * take a seat.
 */
import { getApp, FUNCTIONS_REGION } from "../firebase";

export interface SchoolTeacher {
  email: string;
  name: string;
  /** ms */
  addedAt: number;
  /** someone has signed up with this e-mail */
  hasAccount: boolean;
}

export interface ManagedSchool {
  id: string;
  name: string;
  seats: number;
  /** ms */
  expiresAt: number;
  managerEmails: string[];
  teachers: SchoolTeacher[];
}

/** What the function says went wrong: "no-seats", "in-another-school", "is-manager", "bad-email"… */
export class SchoolError extends Error {}

async function call(data: Record<string, unknown>): Promise<ManagedSchool> {
  const { getFunctions, httpsCallable } = await import("firebase/functions");
  const fn = httpsCallable<Record<string, unknown>, { school: ManagedSchool }>(getFunctions(getApp(), FUNCTIONS_REGION), "manageSchool", { timeout: 60_000 });
  try {
    return (await fn(data)).data.school;
  } catch (err) {
    throw new SchoolError(String((err as { message?: string })?.message ?? ""));
  }
}

export const fetchSchool = () => call({ action: "get" });
export const addTeacher = (email: string, name: string) => call({ action: "addTeacher", email, name });
export const removeTeacher = (email: string) => call({ action: "removeTeacher", email });
export const renameSchool = (name: string) => call({ action: "rename", name });
